import type { CommandResult } from '@travel-planner/shared/schemas';

// CommandResult kinds that mutate page state instead of (or in addition to)
// rendering inside the panel. The panel core treats every such result the
// same way — auto-close drawer, flash the page, surface an Undo toast — so
// every list/search/sort/filter action a future LLM tool returns gets the
// same UX without per-page work.
//
// To add a new kind: register the renderer in your domain's
// `register-xxx-renderer.ts`, add a discriminator branch to the result-data
// schemas in `packages/shared/src/schemas/agent-commands.ts`, and append
// the kind name here.
//
// See `.claude/rules/agent-panel-page-actions.md`.
export const PAGE_ACTION_KINDS = ['apply_filters'] as const;
export type PageActionKind = (typeof PAGE_ACTION_KINDS)[number];

export const isPageActionResult = (result: CommandResult): boolean =>
  (PAGE_ACTION_KINDS as ReadonlyArray<string>).includes(result.kind);
